"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowsProperty = exports.resultsTableRowsPropertyDefinition = void 0;
exports.resultsTableRowsPropertyDefinition = {
    view: { label: 'Results Table Rows' },
    constraints: [
        {
            name: 'properties',
            argument: ['results-table-row'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'results-table-rows',
};
const isResultsTableRowsProperty = (prop) => {
    return prop.name === exports.resultsTableRowsPropertyDefinition.name;
};
exports.isResultsTableRowsProperty = isResultsTableRowsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3dzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1yb3dzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLG9CQUFvQixFQUFFO0lBQ3JDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLENBQUMsbUJBQW1CLENBQUM7U0FDaEM7S0FDRjtJQUNELElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLG9CQUFvQjtDQUNLLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==